import { useEffect, useState } from "react";
import axios from "../helpers/axios";

export const createNewUser = async (values, callback) => {
  const res = await axios.post(`/user/createuser`, values);

  if (res.status === 200) {
    callback(res.data.response);
  } else {
    callback(res.data.response);
  }
};

export const updateUser = async (id, values, callback) => {
  const res = await axios.put(`/user/updateuser/${id}`, values);

  if (res.status === 200) {
    callback(res.data.response);
  } else {
    callback(res.data.response);
  }
};

export const deleteUser = async (id, callback) => {
  const res = await axios.put(`/user/deleteuser/${id}`, null);

  if (res.status === 200) {
    callback(res.data.response);
  } else {
    callback(res.data.response);
  }
};

export const deleteUserByNic = async (nic) => {
  const res = await axios.put(`/user/deleteuserbynic/${nic}`, null);

  if (res.status === 200) {
    // callback(res.data.response);
  } else {
    console.log("User Not Deleted");
  }
};

export const getUsers = async (callback) => {
  const res = await axios.get(`/user/getall/`);

  if (res.status === 200) {
    callback(res.data.response);
  } else {
    callback(res.data.response);
  }
};

export const getAllUsers = async (rowPerPage, pageNumber, search, callback) => {
  const res = await axios.get(`/user/?rowPerPage=${rowPerPage}&pageNumber=${pageNumber}&search=${search}`);

  if (res.status === 200) {
    const userList = res.data.response;
    callback(userList);
  } else {
    callback(res.data.response);
  }
};

export const getUsersById = async (id, callback) => {
  const res = await axios.get(`/user/${id}`);

  if (res.status === 200) {
    const userList = res.data.response.data;
    callback(userList);
  } else {
    callback(res.data.response.data);
  }
};

export const UserAPI = () => {
  const [users, setUsers] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  const [userDetail, setUserDetail] = useState({});

  const [rowPerPage, setRowPerPage] = useState(10);
  const [search, setSearch] = useState("");
  const [pageNumber, setPageNumber] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [callback, setCallback] = useState(false);
  const [id, setId] = useState(0);

  useEffect(() => {
    getAllUsers(rowPerPage, pageNumber, search, (res) => {
      setAllUsers(res);
      setTotalPages(res.totalPages || 1);
    });

    getUsers((res) => {
      setUsers(res);
    });

    getUsersById(id, (res) => {
      setUserDetail(res);
    });
  }, [callback, rowPerPage, search, pageNumber, id]);

  return {
    allUsers: [allUsers, setAllUsers],
    users: [users, setUsers],
    userDetail: [userDetail, setUserDetail],
    id: [id, setId],
    rowPerPage: [rowPerPage, setRowPerPage],
    search: [setSearch],
    pageNumber: [pageNumber, setPageNumber],
    totalPages: [totalPages, setTotalPages],
    callback: [callback, setCallback],
  };
};
